var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationHat02 = function SvgGraduationHat02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 20.156-6.748-3.665v-5.63L1.658 8.897 12 3.267l10.341 5.63v7.466h-1.557V9.76l-2.037 1.102v5.63zm0-7.418L19.1 8.897 12 5.056l-7.102 3.84zm0 5.646 5.19-2.803v-3.89L12 14.526l-5.191-2.833v3.889z"
  })));
};
export default SvgGraduationHat02;